import React from 'react';
import { Row } from '@tencent/tea-component';
import { PureAudioModeProps } from './PureAudioMode.type';
import './PureAudioMode.scss';
import { UserInfoItem } from '@tencent/wemeet-websdk-next';
import { useAttendee } from '@utils/hooks/useUserList';
import AudioBlock from '@component/studio/audio-block';
import { Pagination, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';

const audioPageSize = 18;

const PureAudioMode: React.FC<PureAudioModeProps> = () => {
  const dataset = useAttendee();

  const totalPage = Math.ceil((dataset?.length ?? 0) / audioPageSize);

  const slideArr = new Array(totalPage).fill(undefined);

  return (
    <div className="pureAudio-mode">
      <Swiper
        // install Swiper modules
        modules={[Pagination, Navigation]}
        preventClicksPropagation={false}
        preventClicks={false}
        allowTouchMove={false}
        spaceBetween={50}
        navigation
        slidesPerView={1}
        pagination={{ clickable: true }}
        // FIXME: 下面两个 props 可以删除吗？
        onSwiper={(swiper) => console.log(swiper)}
        onSlideChange={() => console.log('slide change')}
      >
        {slideArr.map((nothing, index) => (
          <SwiperSlide key={index}>
            <Row gap={20} className="pureAudio-mode__row">
              {/* 根据index切分dataset， */}
              {dataset.slice(index * audioPageSize, (index + 1) * audioPageSize).map((user: UserInfoItem) => (
                <AudioBlock
                  user={user}
                  key={`${user?.id?.['@app_uid']}-${user?.id?.['@instance_id']}-${user?.rtcStream?.videoId}`}
                />
              ))}
            </Row>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default React.memo(PureAudioMode);
